import { render, staticRenderFns } from "./previewCreative.vue?vue&type=template&id=b063c118&scoped=true"
import script from "./previewCreative.vue?vue&type=script&lang=js"
export * from "./previewCreative.vue?vue&type=script&lang=js"
import style0 from "./previewCreative.vue?vue&type=style&index=0&id=b063c118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063c118",
  null
  
)

export default component.exports